// Stripping control characters is the whole point here, so the lint rule that
// normally guards against accidental control chars in regexes does not apply.
// eslint-disable-next-line no-control-regex
const CONTROL_CHARS = /[\u0000-\u001f\u007f]/g;

/** Replaces ASCII control characters (which can corrupt UI and logs) with `replacement`. */
export function stripControlChars(text: string, replacement = ''): string {
  return text.replace(CONTROL_CHARS, replacement);
}
